import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from "@/language/localeMessage";
import 'amfe-flexible';
// 系统图标字体：独立字体族 yq-iconfont，避免被 Luckysheet 的 iconfont 覆盖
import "@/assets/font/iconfont.css";
// 页面初始化
const app = createApp(App);
app.use(router);
// 多语言,
app.use(i18n);

// 系统通用组件
// 系统通用组件
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import DetailForm from "@/components/h5/layout/DetailForm.vue";
import YqEmpty from "@/components/YqEmpty.vue";

app.component('YqIcon', YqIcon);
app.component("YqTable", YqTable);
app.component("YqTableColumn", YqTableColumn);
app.component("TableButton", TableButton);
app.component("TableButtonGroup", TableButtonGroup);
app.component("PageButton", PageButton);
app.component("ListPage", ListPage);
app.component("SearchCondition", SearchCondition);
app.component("ListTable", ListTable);
app.component("FormPage", FormPage);
app.component("DetailForm", DetailForm);
app.component("YqEmpty", YqEmpty);
// 加载自定义的函数
import SelfFunction from "@/selfFunction";
SelfFunction.register(app);

// 加载elementUI相关组件，封装到一个文件中进行
import Element from "@/LoadElement";

// 加载ElementUI相关组件
Element.loadElementUi(app);
// 屏蔽错误信息
// app.config.errorHandler = (err) => {
//     console.error(err)
// };
//
// // 屏蔽黄色警告信息
// app.config.warnHandler = (err) => {
//     console.log(err)
// };


app.mount('#app')

